// ui/presenters/degreeOptions.js
import { i18n } from 'boot/i18n';

import { DEGREE_LEVELS, degreeLevelRank } from '../../domain/constants/degree';

/**
 * The education ladder as a picker reads it.
 *
 * HERE RATHER THAN IN `domain/` for the reason `credentialingOptions` gives: naming a rung is
 * translation, and the constant itself must not import `boot/i18n`.
 *
 * ORDERED BY RANK, NEVER ALPHABETICALLY. Every rule that reads a degree asks a comparative question,
 * so a list running associate, bachelor, doctorate, master would invite somebody to read the fourth
 * entry as the highest. The rank is the ordering the ladder already carries.
 *
 * @returns {Array<{ value: string, label: string }>}
 */
export const degreeLevelOptions = () => {
  return Object.values(DEGREE_LEVELS)
    .sort((left, right) => degreeLevelRank(left) - degreeLevelRank(right))
    .map((level) => ({ value: level, label: i18n.t(`staff.qualifications.levels.${level}`) }));
};

/**
 * What one rung is called, or the stored value for anything off the ladder.
 *
 * Falling back to the raw value rather than to "unknown": a record holding a rung this build does
 * not have is still a record somebody entered, and showing what it says is more use to the reader
 * than hiding it behind a placeholder.
 */
export const degreeLevelLabel = (level) => {
  return degreeLevelRank(level) === 0 ? level : i18n.t(`staff.qualifications.levels.${level}`);
};
